import {
    GET_PO_VENDOR_EMAIL,
    SET_PO_VENDOR_EMAIL,
    GET_SEND_PO_VENDOR_EMAIL,
    SET_SEND_PO_VENDOR_EMAIL,
    SET_EMAIL_ATTACHMENTS,
    UPLOAD_EMAIL_ATTACHMENTS,
    REMOVE_EMAIL_ATTACHMENT
} from "./PoVendorEmailType"

const getPoVendorEmail = (payload?: any) => ({
    type: GET_PO_VENDOR_EMAIL,
    payload
});

const setPoVendorEmail = (poVendorEmailDetails: any) => ({
    type: SET_PO_VENDOR_EMAIL,
    poVendorEmailDetails: poVendorEmailDetails
});

const getSendPoVendorEmail = (payload?: any) => ({
    type: GET_SEND_PO_VENDOR_EMAIL,
    payload
});

const setSendPoVendorEmail = (isPoVendorEmailSent: any) => ({
    type: SET_SEND_PO_VENDOR_EMAIL,
    isPoVendorEmailSent: isPoVendorEmailSent
});

const setEmailAttachments = (value: any) => ({
    type: SET_EMAIL_ATTACHMENTS,
    value,
});

const uploadEmailAttachments = (attachmentList: any) => ({
    type: UPLOAD_EMAIL_ATTACHMENTS,
    attachmentList,
});

const removeEmailAttachment = (value: any) => ({
    type: REMOVE_EMAIL_ATTACHMENT,
    value,
});

export {
    getPoVendorEmail,
    setPoVendorEmail,
    getSendPoVendorEmail,
    setSendPoVendorEmail,
    setEmailAttachments,
    uploadEmailAttachments,
    removeEmailAttachment
}
